import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

const Edit = ({ onEditClicked, item, isDisabled = false }) => {
  const handleEditClick = () => onEditClicked(item);

  return (
    <span data-toggle="modal" data-target="#ImageCropperModal">
      <OverlayTrigger
        placement="top"
        overlay={<Tooltip id={`tooltip-edit-button-${item?.id}`} style={{ margin: 0 }}>Edit Photo</Tooltip>}
      >
        <Button
          name="btnEditImage"
          onClick={handleEditClick}
          disabled={isDisabled}
          size="sm"
          style={{
            borderTopRightRadius: '0',
            borderBottomRightRadius: '0',
            borderTopLeftRadius: '4px',
            borderBottomLeftRadius: '4px',
          }}
        >
          <i className="far fa-edit" />
        </Button>
      </OverlayTrigger>
    </span>
  );
};

Edit.propTypes = {
  isDisabled: PropTypes.bool,
  onEditClicked: PropTypes.func,
  item: PropTypes.oneOfType([PropTypes.string, PropTypes.shape()]),
};

export default Edit;
